/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchBillCreateReqVo,
  BillCreateReqVo,
  BillDetailAdditionalServiceCreateReqVo,
  BillDetailGoodsCreateReqVo,
  PurchaseCancelBillCreateReqVo,
  ResponseAdminBillListVo,
  ResponseBatchBillCreateRespVo,
  ResponseBillCreateRespVo,
  ResponseBillDetailVo,
  ResponseBillListVo,
  ResponseBillPreCheckRespVo,
  ResponseBoolean,
  ResponseCnyWalletBillListVo,
  ResponseListBillDetailAdditionalServiceVo,
  ResponseListBillDetailVo,
  ResponseListEnumItem,
  ResponseListLong,
  ResponseLong,
  ResponsePurchaseCancelBillCreateRespVo,
  ResponseVoid,
} from '../models/index';
import {
    BatchBillCreateReqVoFromJSON,
    BatchBillCreateReqVoToJSON,
    BillCreateReqVoFromJSON,
    BillCreateReqVoToJSON,
    BillDetailAdditionalServiceCreateReqVoFromJSON,
    BillDetailAdditionalServiceCreateReqVoToJSON,
    BillDetailGoodsCreateReqVoFromJSON,
    BillDetailGoodsCreateReqVoToJSON,
    PurchaseCancelBillCreateReqVoFromJSON,
    PurchaseCancelBillCreateReqVoToJSON,
    ResponseAdminBillListVoFromJSON,
    ResponseAdminBillListVoToJSON,
    ResponseBatchBillCreateRespVoFromJSON,
    ResponseBatchBillCreateRespVoToJSON,
    ResponseBillCreateRespVoFromJSON,
    ResponseBillCreateRespVoToJSON,
    ResponseBillDetailVoFromJSON,
    ResponseBillDetailVoToJSON,
    ResponseBillListVoFromJSON,
    ResponseBillListVoToJSON,
    ResponseBillPreCheckRespVoFromJSON,
    ResponseBillPreCheckRespVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseCnyWalletBillListVoFromJSON,
    ResponseCnyWalletBillListVoToJSON,
    ResponseListBillDetailAdditionalServiceVoFromJSON,
    ResponseListBillDetailAdditionalServiceVoToJSON,
    ResponseListBillDetailVoFromJSON,
    ResponseListBillDetailVoToJSON,
    ResponseListEnumItemFromJSON,
    ResponseListEnumItemToJSON,
    ResponseListLongFromJSON,
    ResponseListLongToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePurchaseCancelBillCreateRespVoFromJSON,
    ResponsePurchaseCancelBillCreateRespVoToJSON,
    ResponseVoidFromJSON,
    ResponseVoidToJSON,
} from '../models/index';

export interface BillAdditionalServiceExportGetRequest {
    orderIds: Array<number>;
}

export interface BillAdminCnyWalletListGetRequest {
    currentPage?: number;
    pageSize?: number;
    billType?: Array<number>;
    status?: number;
    billId?: number;
    cardHolderName?: string;
    userBusinessType?: number;
    createTimeStart?: string;
    createTimeEnd?: string;
    userName?: string;
    userCode?: string;
}

export interface BillAdminListGetRequest {
    currentPage?: number;
    pageSize?: number;
    billType?: Array<number>;
    status?: number;
    billId?: number;
    cardHolderName?: string;
    cardNumber?: string;
    createTimeStart?: string;
    createTimeEnd?: string;
    userName?: string;
    userCode?: string;
}

export interface BillBatchCreatePostRequest {
    batchBillCreateReqVo?: BatchBillCreateReqVo;
}

export interface BillCancelBillIdPostRequest {
    billId: number;
}

export interface BillCheckUnpaidGetRequest {
    orderCode: string;
}

export interface BillConfirmBillIdPostRequest {
    billId: number;
    remark?: string;
}

export interface BillCreatePostRequest {
    billCreateReqVo?: BillCreateReqVo;
}

export interface BillDeleteBillIdPostRequest {
    billId: number;
}

export interface BillDetailAdditionalServiceCreatePostRequest {
    billDetailAdditionalServiceCreateReqVo?: BillDetailAdditionalServiceCreateReqVo;
}

export interface BillDetailAdditionalServiceListGetRequest {
    additionalServiceId: number;
}

export interface BillDetailAdditionalServicePaidServiceIdsGetRequest {
    orderCode: string;
    billTypes: Array<number>;
}

export interface BillDetailGoodsCreatePostRequest {
    billDetailGoodsCreateReqVo?: BillDetailGoodsCreateReqVo;
}

export interface BillDetailIdGetRequest {
    id: number;
}

export interface BillDetailListByTargetGetRequest {
    targetId: number;
    billType?: number;
}

export interface BillDetailListGetRequest {
    orderCode: string;
    billType?: number;
}

export interface BillIdByCodeGetRequest {
    billCode: string;
}

export interface BillListGetRequest {
    currentPage?: number;
    pageSize?: number;
    billType?: Array<number>;
    status?: number;
    billCode?: string;
    orderCode?: string;
    userId?: number;
    warehouseId?: number;
    userName?: string;
    userCode?: string;
    createDateStart?: string;
    createDateEnd?: string;
}

export interface BillPrecheckGetRequest {
    orderCode: string;
    billType: number;
    userId?: number;
}

export interface BillPurchaseCancelCreatePostRequest {
    purchaseCancelBillCreateReqVo?: PurchaseCancelBillCreateReqVo;
}

export interface BillResetPostRequest {
    orderCode: string;
    billType: number;
}

export interface BillTransferPostRequest {
    orderCode: string;
    billType: number;
}

/**
 * 
 */
export class BillControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 附加费用下载：按订单id列表导出billType=3已支付账单的附加服务费用（动态服务列）
     */
    async billAdditionalServiceExportGetRaw(requestParameters: BillAdditionalServiceExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderIds'] == null) {
            throw new runtime.RequiredError(
                'orderIds',
                'Required parameter "orderIds" was null or undefined when calling billAdditionalServiceExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/additional-service/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 附加费用下载：按订单id列表导出billType=3已支付账单的附加服务费用（动态服务列）
     */
    async billAdditionalServiceExportGet(requestParameters: BillAdditionalServiceExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.billAdditionalServiceExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理员分页查询人民币钱包账单列表
     */
    async billAdminCnyWalletListGetRaw(requestParameters: BillAdminCnyWalletListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCnyWalletBillListVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['billId'] != null) {
            queryParameters['billId'] = requestParameters['billId'];
        }

        if (requestParameters['cardHolderName'] != null) {
            queryParameters['cardHolderName'] = requestParameters['cardHolderName'];
        }

        if (requestParameters['userBusinessType'] != null) {
            queryParameters['userBusinessType'] = requestParameters['userBusinessType'];
        }

        if (requestParameters['createTimeStart'] != null) {
            queryParameters['createTimeStart'] = requestParameters['createTimeStart'];
        }

        if (requestParameters['createTimeEnd'] != null) {
            queryParameters['createTimeEnd'] = requestParameters['createTimeEnd'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/admin/cny-wallet/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCnyWalletBillListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理员分页查询人民币钱包账单列表
     */
    async billAdminCnyWalletListGet(requestParameters: BillAdminCnyWalletListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCnyWalletBillListVo> {
        const response = await this.billAdminCnyWalletListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理员分页查询账单列表（钱包相关）
     */
    async billAdminListGetRaw(requestParameters: BillAdminListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminBillListVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['billId'] != null) {
            queryParameters['billId'] = requestParameters['billId'];
        }

        if (requestParameters['cardHolderName'] != null) {
            queryParameters['cardHolderName'] = requestParameters['cardHolderName'];
        }

        if (requestParameters['cardNumber'] != null) {
            queryParameters['cardNumber'] = requestParameters['cardNumber'];
        }

        if (requestParameters['createTimeStart'] != null) {
            queryParameters['createTimeStart'] = requestParameters['createTimeStart'];
        }

        if (requestParameters['createTimeEnd'] != null) {
            queryParameters['createTimeEnd'] = requestParameters['createTimeEnd'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/admin/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminBillListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理员分页查询账单列表（钱包相关）
     */
    async billAdminListGet(requestParameters: BillAdminListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminBillListVo> {
        const response = await this.billAdminListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量创建账单
     */
    async billBatchCreatePostRaw(requestParameters: BillBatchCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBatchBillCreateRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bill/batch-create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchBillCreateReqVoToJSON(requestParameters['batchBillCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBatchBillCreateRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 批量创建账单
     */
    async billBatchCreatePost(requestParameters: BillBatchCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBatchBillCreateRespVo> {
        const response = await this.billBatchCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取账单类型枚举列表
     */
    async billBillTypeEnumListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListEnumItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/bill-type-enum/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListEnumItemFromJSON(jsonValue));
    }

    /**
     * 
     * 获取账单类型枚举列表
     */
    async billBillTypeEnumListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListEnumItem> {
        const response = await this.billBillTypeEnumListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 取消账单（将账单状态更新为已取消）
     */
    async billCancelBillIdPostRaw(requestParameters: BillCancelBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling billCancelBillIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/cancel/{billId}`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 取消账单（将账单状态更新为已取消）
     */
    async billCancelBillIdPost(requestParameters: BillCancelBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.billCancelBillIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 校验订单是否存在未支付账单（供前端按钮拦截用）
     */
    async billCheckUnpaidGetRaw(requestParameters: BillCheckUnpaidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseVoid>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billCheckUnpaidGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/check-unpaid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseVoidFromJSON(jsonValue));
    }

    /**
     * 
     * 校验订单是否存在未支付账单（供前端按钮拦截用）
     */
    async billCheckUnpaidGet(requestParameters: BillCheckUnpaidGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseVoid> {
        const response = await this.billCheckUnpaidGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端钱包相关记录使用，最后会创建支付记录
     * 确认账单（将账单状态更新为已支付，仅支持钱包充值提款相关类型）
     */
    async billConfirmBillIdPostRaw(requestParameters: BillConfirmBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling billConfirmBillIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['remark'] != null) {
            queryParameters['remark'] = requestParameters['remark'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/confirm/{billId}`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 管理端钱包相关记录使用，最后会创建支付记录
     * 确认账单（将账单状态更新为已支付，仅支持钱包充值提款相关类型）
     */
    async billConfirmBillIdPost(requestParameters: BillConfirmBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.billConfirmBillIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 不同账单类型对应的参数不同
     * 创建账单
     */
    async billCreatePostRaw(requestParameters: BillCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBillCreateRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bill/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillCreateReqVoToJSON(requestParameters['billCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBillCreateRespVoFromJSON(jsonValue));
    }

    /**
     * 不同账单类型对应的参数不同
     * 创建账单
     */
    async billCreatePost(requestParameters: BillCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBillCreateRespVo> {
        const response = await this.billCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除账单（逻辑删除）
     */
    async billDeleteBillIdPostRaw(requestParameters: BillDeleteBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['billId'] == null) {
            throw new runtime.RequiredError(
                'billId',
                'Required parameter "billId" was null or undefined when calling billDeleteBillIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/delete/{billId}`.replace(`{${"billId"}}`, encodeURIComponent(String(requestParameters['billId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 删除账单（逻辑删除）
     */
    async billDeleteBillIdPost(requestParameters: BillDeleteBillIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.billDeleteBillIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建账单附加服务明细
     */
    async billDetailAdditionalServiceCreatePostRaw(requestParameters: BillDetailAdditionalServiceCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bill/detail-additional-service/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillDetailAdditionalServiceCreateReqVoToJSON(requestParameters['billDetailAdditionalServiceCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 创建账单附加服务明细
     */
    async billDetailAdditionalServiceCreatePost(requestParameters: BillDetailAdditionalServiceCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.billDetailAdditionalServiceCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据附加服务ID查询账单附加服务明细列表
     */
    async billDetailAdditionalServiceListGetRaw(requestParameters: BillDetailAdditionalServiceListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBillDetailAdditionalServiceVo>> {
        if (requestParameters['additionalServiceId'] == null) {
            throw new runtime.RequiredError(
                'additionalServiceId',
                'Required parameter "additionalServiceId" was null or undefined when calling billDetailAdditionalServiceListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['additionalServiceId'] != null) {
            queryParameters['additionalServiceId'] = requestParameters['additionalServiceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/detail-additional-service/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBillDetailAdditionalServiceVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据附加服务ID查询账单附加服务明细列表
     */
    async billDetailAdditionalServiceListGet(requestParameters: BillDetailAdditionalServiceListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBillDetailAdditionalServiceVo> {
        const response = await this.billDetailAdditionalServiceListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 查询指定订单下已支付账单所选的附加服务ID列表（去重），用于创建账单前的附加服务过滤（如billType=9韩国库存入库账单），支持传多个账单类型
     */
    async billDetailAdditionalServicePaidServiceIdsGetRaw(requestParameters: BillDetailAdditionalServicePaidServiceIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListLong>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billDetailAdditionalServicePaidServiceIdsGet().'
            );
        }

        if (requestParameters['billTypes'] == null) {
            throw new runtime.RequiredError(
                'billTypes',
                'Required parameter "billTypes" was null or undefined when calling billDetailAdditionalServicePaidServiceIdsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['billTypes'] != null) {
            queryParameters['billTypes'] = requestParameters['billTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/detail-additional-service/paid-service-ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListLongFromJSON(jsonValue));
    }

    /**
     * 
     * 查询指定订单下已支付账单所选的附加服务ID列表（去重），用于创建账单前的附加服务过滤（如billType=9韩国库存入库账单），支持传多个账单类型
     */
    async billDetailAdditionalServicePaidServiceIdsGet(requestParameters: BillDetailAdditionalServicePaidServiceIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListLong> {
        const response = await this.billDetailAdditionalServicePaidServiceIdsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建账单货物明细
     */
    async billDetailGoodsCreatePostRaw(requestParameters: BillDetailGoodsCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bill/detail-goods/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillDetailGoodsCreateReqVoToJSON(requestParameters['billDetailGoodsCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 创建账单货物明细
     */
    async billDetailGoodsCreatePost(requestParameters: BillDetailGoodsCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.billDetailGoodsCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据ID获取账单详情
     */
    async billDetailIdGetRaw(requestParameters: BillDetailIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBillDetailVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling billDetailIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/detail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBillDetailVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据ID获取账单详情
     */
    async billDetailIdGet(requestParameters: BillDetailIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBillDetailVo> {
        const response = await this.billDetailIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据关联实体ID和账单类型查询账单详情列表
     */
    async billDetailListByTargetGetRaw(requestParameters: BillDetailListByTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBillDetailVo>> {
        if (requestParameters['targetId'] == null) {
            throw new runtime.RequiredError(
                'targetId',
                'Required parameter "targetId" was null or undefined when calling billDetailListByTargetGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['targetId'] != null) {
            queryParameters['targetId'] = requestParameters['targetId'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/detail/list-by-target`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBillDetailVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据关联实体ID和账单类型查询账单详情列表
     */
    async billDetailListByTargetGet(requestParameters: BillDetailListByTargetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBillDetailVo> {
        const response = await this.billDetailListByTargetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据订单编码和账单类型查询账单详情列表；返回的billType=28记录通过targetId附带originalBill原账单完整详情（含货物、附加服务、通用明细及原支付信息），仅关联一层；原账单不存在、已删除、停用或会员不匹配时为空。
     */
    async billDetailListGetRaw(requestParameters: BillDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBillDetailVo>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billDetailListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/detail/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBillDetailVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据订单编码和账单类型查询账单详情列表；返回的billType=28记录通过targetId附带originalBill原账单完整详情（含货物、附加服务、通用明细及原支付信息），仅关联一层；原账单不存在、已删除、停用或会员不匹配时为空。
     */
    async billDetailListGet(requestParameters: BillDetailListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBillDetailVo> {
        const response = await this.billDetailListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据账单编号查询账单ID
     */
    async billIdByCodeGetRaw(requestParameters: BillIdByCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['billCode'] == null) {
            throw new runtime.RequiredError(
                'billCode',
                'Required parameter "billCode" was null or undefined when calling billIdByCodeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['billCode'] != null) {
            queryParameters['billCode'] = requestParameters['billCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/id-by-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 根据账单编号查询账单ID
     */
    async billIdByCodeGet(requestParameters: BillIdByCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.billIdByCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分页查询账单列表
     */
    async billListGetRaw(requestParameters: BillListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBillListVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['billCode'] != null) {
            queryParameters['billCode'] = requestParameters['billCode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['createDateStart'] != null) {
            queryParameters['createDateStart'] = requestParameters['createDateStart'];
        }

        if (requestParameters['createDateEnd'] != null) {
            queryParameters['createDateEnd'] = requestParameters['createDateEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBillListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分页查询账单列表
     */
    async billListGet(requestParameters: BillListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBillListVo> {
        const response = await this.billListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 账单生成预检（打开弹窗时调用，校验订单数据是否满足账单生成条件，返回订单快照供保存时一致性校验）
     */
    async billPrecheckGetRaw(requestParameters: BillPrecheckGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBillPreCheckRespVo>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billPrecheckGet().'
            );
        }

        if (requestParameters['billType'] == null) {
            throw new runtime.RequiredError(
                'billType',
                'Required parameter "billType" was null or undefined when calling billPrecheckGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/precheck`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBillPreCheckRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 账单生成预检（打开弹窗时调用，校验订单数据是否满足账单生成条件，返回订单快照供保存时一致性校验）
     */
    async billPrecheckGet(requestParameters: BillPrecheckGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBillPreCheckRespVo> {
        const response = await this.billPrecheckGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 代买取消原子创建：同一事务内完成拆单、代买取消手续费账单(2)、适用阶段的退款账单(20)创建及退款到账；未支付阶段（含客户整单申请取消）仅生成手续费账单，原代买账单在同一事务内废弃，前端代买取消保存由两次/bill/create改为单次调用本接口，消除拆单后退款校验失败的中间态
     */
    async billPurchaseCancelCreatePostRaw(requestParameters: BillPurchaseCancelCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePurchaseCancelBillCreateRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bill/purchase-cancel/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseCancelBillCreateReqVoToJSON(requestParameters['purchaseCancelBillCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePurchaseCancelBillCreateRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 代买取消原子创建：同一事务内完成拆单、代买取消手续费账单(2)、适用阶段的退款账单(20)创建及退款到账；未支付阶段（含客户整单申请取消）仅生成手续费账单，原代买账单在同一事务内废弃，前端代买取消保存由两次/bill/create改为单次调用本接口，消除拆单后退款校验失败的中间态
     */
    async billPurchaseCancelCreatePost(requestParameters: BillPurchaseCancelCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePurchaseCancelBillCreateRespVo> {
        const response = await this.billPurchaseCancelCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 重置账单（删除账单并回退订单状态到生成账单前）
     */
    async billResetPostRaw(requestParameters: BillResetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billResetPost().'
            );
        }

        if (requestParameters['billType'] == null) {
            throw new runtime.RequiredError(
                'billType',
                'Required parameter "billType" was null or undefined when calling billResetPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/reset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 重置账单（删除账单并回退订单状态到生成账单前）
     */
    async billResetPost(requestParameters: BillResetPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.billResetPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 费用转账处理（确认账单关联的待确认支付记录）
     */
    async billTransferPostRaw(requestParameters: BillTransferPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['orderCode'] == null) {
            throw new runtime.RequiredError(
                'orderCode',
                'Required parameter "orderCode" was null or undefined when calling billTransferPost().'
            );
        }

        if (requestParameters['billType'] == null) {
            throw new runtime.RequiredError(
                'billType',
                'Required parameter "billType" was null or undefined when calling billTransferPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bill/transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 费用转账处理（确认账单关联的待确认支付记录）
     */
    async billTransferPost(requestParameters: BillTransferPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.billTransferPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
